/* eslint-disable no-inner-declarations */
/* eslint-disable no-empty */
/**
 * External Dependencies
 */
import 'jquery';
import './wpm/accordion';
import './wpm/custom-quantity';
import './wpm/mobile-menu';
import './wpm/membership';
import './wpm/subscription';
import './wpm/my-account';
import './wpm/sliders/top-bar-slider';
import './wpm/weekly-challenge';
import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();
import Swiper from 'swiper/bundle';
import MicroModal from 'micromodal';
import collapse from '@alpinejs/collapse'
import jquery from 'jquery';

Alpine.plugin(collapse)
MicroModal.init({});

const htmlElement = document.documentElement;
const langValue = htmlElement.getAttribute("lang");


document.addEventListener("DOMContentLoaded", function () {
  function scrollToAnchor(targetId) {
    const target = document.querySelector(targetId);
    const header = document.querySelector('.header-main');
    const offset = (header ? header.offsetHeight : 0) + 100;

    if (target) {
      const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth"
      });
    }
  }

  // Handle page load with anchor
  if (window.location.hash) {
    setTimeout(() => scrollToAnchor(window.location.hash), 100); // Delay ensures proper positioning
  }

  // Handle clicks on anchor links (without reloading)
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href");

      if (targetId.length > 1) { // Ensure it's a valid ID and not just "#"
        e.preventDefault(); // Stop default instant jump
        history.pushState(null, null, targetId); // Update URL without reloading

        setTimeout(() => scrollToAnchor(targetId), 100); // Delay to ensure proper scroll
      }
    });
  });
});




// Swiper
(function () {
  var swiperHero = new Swiper('.swiper-hero', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 3000,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  var swiperMembershipBenefits = new Swiper('.swiper-membership-benefits', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        if (index === 0) {
          let allText;
          if(langValue === 'de-DE'){
            allText = 'ALLE';
          } else {
            allText = 'ALL';
          }
          return '<span class="' + className + '">' + allText + '</span>';
        } else {
          return '<span class="' + className + '">' + index + '</span>';
        }
      },
    },
  });

  var swiperSubscriptionWhatIsInside = new Swiper('.swiper-subscription-what-is-inside', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        if (index === 0) {
          let allText;
          if (langValue === 'de-DE') {
            allText = 'ALLE';
          } else {
            allText = 'ALL';
          }
          return '<span class="' + className + '">' + allText + '</span>';
        } else {
          return '<span class="' + className + '">' + index + '</span>';
        }
      },
    },
  });

  var swiperSubscriptionPlans = new Swiper('.swiper-subscription-variation-plans', {
    slidesPerView: 1,
    initialSlide: 1,
    spaceBetween: 0,
    centeredSlides: true,
  });

  var swiperSubscriptionReviews = new Swiper('.swiper-subscription-reviews', {
    slidesPerView: 2,
    spaceBetween: 40,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + '</span>';
      },
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1080: {
        slidesPerView: 2,
        spaceBetween: 80,
      },
    },
  });

  var swiperModules = new Swiper('.swiper-modules', {
    slidesPerView: 1.5,
    spaceBetween: 40,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 1.5,
        spaceBetween: 20,
        centeredSlides: !0,
        loop: true,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 40,
        centeredSlides: !1,
        loop: true,
      },
    },
  });

  var hasCatsReviews = document.querySelector('.cats-reviews .swiper-reviews') !== null;
  var swiperReviews = new Swiper('.swiper-reviews', {
    slidesPerView: 1,
    spaceBetween: 10,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: hasCatsReviews ? 32 : 10,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: hasCatsReviews ? 48 : 10,
      },
    },
  });

  var swiperReviewsProduct = new Swiper('.swiper-reviews-product', {
    slidesPerView: 1,
    spaceBetween: 10,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
    },
  });

  var swiperWhy = new Swiper('.swiper-why-pawzler', {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 20,
    loop: true,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  var swiperProductGallery = new Swiper('.swiper-product-gallery', {
    slidesPerView: 1.5,
    centeredSlides: true,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

})();

jQuery(function ($) {

  $(document).ready(function () {

    //pull div to right out of container
    if ($("div").hasClass("pull-right")) {
      let w = $(window).width();
      let containerWidth = $('.container').width();
      let imageOffset = (w - containerWidth) / 2;
      $("div.pull-right").css("margin-right", "-" + imageOffset + "px");
    }

    //scroll to top btn
    $("#btn-top").on('click', function () {
      $("html, body").animate({
        scrollTop: 0,
      }, "slow");
      return false;
    });

    if ($("div").hasClass("menu-down-height")) {
      let headerHeight = $('.header-main').height();
      $(".menu-down-height").css("top", headerHeight + "px");
    }

    // UU QUANTTY
    $('.uu-quantity label').on('click', function () {
      $(".uu-quantity label").removeClass("active");
      $(this).addClass("active");
      $(this).prev().trigger("click");
    });

    // ZOOM IMAGES ON CLICK PRODUCT PAGE
    $('.wrap-inside .wrap-slide').on('click', function () {

      $('.wrap-inside').toggleClass("md:grid-cols-1 md:grid-cols-2");

    });

    //uu quantity
    setTimeout(function () {
      $('.uu-quantity input').eq(1).trigger('click');
      $('.set-includes-div').eq(1).removeClass("hidden");
      $('.product-image-wrap:nth-child(2)').removeClass("hidden");
    }, 1);

    $('.uu-quantity input').on('click', function () {
      let value = $(this).attr('value'); //get the value

      //increment value for the nth-child selector to work

      $('#pa_package')
        .find('option[value="' + value + '"]')
        .prop('selected', true)
        .trigger('change'); //trigger a change instead of click

      return false;
    });

    $(".uu-quantity label").on('click', function () {
      let value = $('.uu-quantity input:checked').val();

      $(".set-includes-div").addClass("hidden");
      $(".set-includes-div[data-id='" + value + "']").removeClass("hidden");

      $(".product-image-wrap").addClass("hidden");
      $(".product-image-wrap[data-id='" + value + "']").removeClass("hidden");

    });

  });

});
